export default "__VITE_ASSET__eAUlpYTx__"